import { Header } from 'antd/lib/layout/layout';
import { FC } from 'react';
import { Logout } from 'features/Logout';
import favicon from 'shared/images/header_logo.png';
import styles from './AppHeader.module.scss';

export const AppHeader: FC = () => (
  <Header className={styles.header}>
    <div className={styles.headerItemsContainer}>
      <div className={styles.appTitle}>
        <img src={favicon} alt="Логотип" className={styles.logo} />
      </div>
      <div className={styles.headerRight}>
        <Logout />
      </div>
    </div>
  </Header>
);
